import { render } from "./PricesAndPromo.vue?vue&type=template&id=f2fd2148&scoped=true"
import script from "./PricesAndPromo.vue?vue&type=script&lang=js"
export * from "./PricesAndPromo.vue?vue&type=script&lang=js"

import "./PricesAndPromo.vue?vue&type=style&index=0&id=f2fd2148&scoped=true&lang=css"

import exportComponent from "/home/forge/backoffice.callmewine.co.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2fd2148"]])

export default __exports__